import { CircularProgressDeterminate } from '@/components/loaders/CircularProgressDeterminate'
import { UploadTaskStatus } from './FilesDropZone'

interface FileUploadStatusListProps {
  tasks: Map<string, UploadTaskStatus>
  scrollRef: React.RefObject<HTMLDivElement>
}

const FileUploadStatusList = (props: FileUploadStatusListProps) => {
  const { tasks, scrollRef } = props

  const statusComponents = Array.from(tasks).map(([key, value]) => (
    <div key={key} className="mt-4">
      <div className="grid grid-cols-[auto_30px] items-center">
        <p className="text-sm overflow-hidden">{value.uploadableFile.fileName}</p>
        <CircularProgressDeterminate value={value.progress} error={!!value.errorMessage} />
      </div>
      {value.errorMessage && <p className="text-red-600 text-xs mt-1">{value.errorMessage}</p>}
    </div>
  ))

  return (
    <div className="overflow-y-auto max-h-96 pr-1 pb-2" ref={scrollRef}>
      {statusComponents}
    </div>
  )
}

export { FileUploadStatusList }
